/**
 * Supported button sizes for ButtonV2
 */
var BUTTON_SIZES;
(function (BUTTON_SIZES) {
    BUTTON_SIZES["EXTRA_SMALL"] = "xs";
    BUTTON_SIZES["SMALL"] = "s";
    BUTTON_SIZES["MEDIUM"] = "m";
    BUTTON_SIZES["LARGE"] = "l";
})(BUTTON_SIZES || (BUTTON_SIZES = {}));
/**
 * Supported button styles for ButtonV2
 */
var BUTTON_COLOR_STYLES;
(function (BUTTON_COLOR_STYLES) {
    BUTTON_COLOR_STYLES["DEFAULT"] = "default";
    BUTTON_COLOR_STYLES["PRIMARY"] = "primary";
    BUTTON_COLOR_STYLES["SECONDARY"] = "secondary";
    BUTTON_COLOR_STYLES["ACTIVE"] = "active";
    BUTTON_COLOR_STYLES["WARNING"] = "warning";
    BUTTON_COLOR_STYLES["DANGER"] = "danger";
    BUTTON_COLOR_STYLES["INFO"] = "info";
    BUTTON_COLOR_STYLES["DARK"] = "dark";
    BUTTON_COLOR_STYLES["LIGHT"] = "light";
})(BUTTON_COLOR_STYLES || (BUTTON_COLOR_STYLES = {}));
export { BUTTON_SIZES, BUTTON_COLOR_STYLES };
//# sourceMappingURL=Button.js.map